import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import { useQuery } from '@tanstack/react-query'
import { twMerge as twm } from 'tailwind-merge'

import { apiClient } from '../../../modules/apiclient'
import { GoogleMapsAPIKey } from '../../../utils/constants'
import { Icon } from '../../Icon'
import Card from '../../app/design/Card'

interface LocationSectionProps {
    location: string
    latLong?: {
        latitude: number
        longitude: number
    }
    title?: string
}

export const LocationSection = ({ location, latLong, title }: LocationSectionProps) => {
    const { data: geocodeResponse } = useQuery({
        queryKey: ['geocode', location],
        queryFn: () => apiClient.post('/location/geocode', { q: location }),
        enabled: latLong === undefined,
    })

    const effectiveCoordinates =
        latLong !== undefined
            ? latLong
            : geocodeResponse?.data?.latitude !== undefined &&
                geocodeResponse?.data?.longitude !== undefined
              ? {
                    latitude: geocodeResponse.data.latitude,
                    longitude: geocodeResponse.data.longitude,
                }
              : null

    const { isLoaded: isMapLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GoogleMapsAPIKey,
    })

    return (
        <Card size="sm" title={title ?? 'Address'}>
            <a
                href={`https://maps.google.com/?q=${location}`}
                className={twm(
                    'text-primary-700 mt-6 block font-bold',
                    effectiveCoordinates !== null && 'mb-6'
                )}
                target="_blank"
                rel="noreferrer"
            >
                <span className="underline">{location}</span>{' '}
                <Icon icon="externalLink.medium" className="inline" />
            </a>

            {effectiveCoordinates !== null && isMapLoaded && (
                <GoogleMap
                    center={{
                        lat: effectiveCoordinates.latitude,
                        lng: effectiveCoordinates.longitude,
                    }}
                    zoom={15}
                    clickableIcons={false}
                    mapContainerStyle={{ width: '312px', height: '236px' }}
                    options={{ disableDefaultUI: true }}
                >
                    <Marker
                        position={{
                            lat: effectiveCoordinates.latitude,
                            lng: effectiveCoordinates.longitude,
                        }}
                    />
                </GoogleMap>
            )}
        </Card>
    )
}
